module.exports = __webpack_public_path__ + "static/media/ccard-dinner.16a8d59f.svg";